import { render, staticRenderFns } from "./DisplayExpansionPanelHeader.vue?vue&type=template&id=8f85eadc"
import script from "./DisplayExpansionPanelHeader.vue?vue&type=script&lang=js"
export * from "./DisplayExpansionPanelHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports